<template>
  <div class="text-end mb-3">
    <button
      class="btn btn-primary"
      title="Exportar para Excel"
      @click="exportToExcel"
    >
      Exportar para Excel
    </button>
  </div>
  <div class="card">
    <div class="table-responsive">
      <table
        class="table table-sm table-bordered table-striped"
        id="tableReport"
      >
        <thead class="bg-teal text-white text-center">
          <tr>
            <th width="20%">Item</th>
            <th width="15%">Valor</th>
            <th width="65%">Memória de Cálculo</th>
          </tr>
        </thead>
        <tbody>
          <template
            v-for="ccPai in reports.centrosCustos"
            :key="ccPai.codCCustoPai"
          >
            <tr>
              <td colspan="3">
                <strong>
                  {{ ccPai.codCCustoPai }} -
                  {{ ccPai.nomeCCustoPai }}
                </strong>
              </td>
            </tr>
            <tr v-for="receita in ccPai.receitas" :key="receita.id">
              <td class="fs-smxs">
                {{ receita.nome }}
              </td>
              <td class="fs-smxs text-center">
                {{
                  reports.periodoOrcamento == 1
                    ? moneyToCurrencyBr(receita.proposta)
                    : moneyToCurrencyBr(receita.reformulacao)
                }}
              </td>
              <td class="fs-smxs">
                {{ receita.descricao }}
              </td>
            </tr>
            <tr class="table-primary">
              <td>
                <strong>
                  Total do Centro de Custo ({{ ccPai.codCCustoPai }})
                </strong>
              </td>
              <td class="text-center fs-smxs">
                <strong>
                  {{ moneyToCurrencyBr(ccPai.total) }}
                </strong>
              </td>
              <td></td>
            </tr>
          </template>
          <tr class="table-success">
            <td><strong>Total Geral</strong></td>
            <td class="text-center fs-smxs">
              <strong>
                {{ moneyToCurrencyBr(reports.totais) }}
              </strong>
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { moneyToCurrencyBr } from '@/utils/strings'
import '@/assets/js/jquery.table2excel'

export default {
  name: 'ReceitaResult',

  props: {
    reports: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      moneyToCurrencyBr,
    }
  },

  methods: {
    exportToExcel() {
      window.$('#tableReport').table2excel({
        name: 'Receita',
        filename: 'Relatorio_SGCC_Receita.xls',
      })
    },
  },
}
</script>

<style scoped>
td {
  padding: 0.3rem;
}
</style>
